<template>
  <div class="hello">
    <div class="container">
      <p style="font-size: 25px">{{ $t("common.zhucedenglu") }}</p>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        class="demo-ruleForm"
      >
        <el-form-item label="" prop="userName">
          <el-input
            :placeholder="$t('login.email')"
            v-model="ruleForm.userName"
          ></el-input>
        </el-form-item>
        <br />
        <el-form-item label="" prop="passWord">
          <el-input
            :placeholder="$t('login.password')"
            v-model="ruleForm.passWord"
            type="password"
            @keyup.enter.native="Login"
          ></el-input>
        </el-form-item>
      </el-form>
<!--      <a class="forget" @click="$router.push('/register')">-->
<!--        {{ $t("button.zhuce") }}-->
<!--      </a>-->
      <div class="register" @click="$router.push('/register')">
        {{ $t("button.zhuce") }}
      </div>
      <el-button
        type="primary"
        style="width: 100%; margin-top: 10px"
        @click="Login"
        >{{ $t("common.login") }}</el-button
      >
    </div>
  </div>
</template>

<script>
import { login_fetch } from "@/api/user";
export default {
  components: {},
  data() {
    return {
      ruleForm: {
        userName: null,
        passWord: null,
      },
      rules: {
        userName: [
          {
            required: true,
            message: this.$t("login.email"),
            trigger: "blur",
          },
        ],
        passWord: [
          {
            required: true,
            message: this.$t("login.password"),
            trigger: "blur",
          },
        ],
      },
      isToCart: false,
    };
  },

  computed: {},

  mounted() {
    this.$route.query.rediect
      ? (this.isToCart = true)
      : (this.isToCart = false);

    if (sessionStorage.getItem("userID")) {
      this.$router.push("/shoppingCart");
    }
  },

  methods: {
    Login() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          login_fetch({
            email: this.ruleForm.userName,
            password: this.ruleForm.passWord,
          }).then((res) => {
            // console.log(res);
            if (res.code == 200) {
              sessionStorage.setItem("userInfo", res.data.name);
              sessionStorage.setItem("userID", res.data.userId);
              if (this.isToCart) {
                this.$router.push("/shoppingCart");
              } else {
                this.$router.push({
                  name: "ShopList",
                });
              }
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style scoped>
.hello {
  position: absolute;
  height: 100%;
  width: 100%;
  background: url("../assets/bg-login.png") no-repeat;
  background-size: 100% 100%;
}
.bgImg {
  width: 100%;
  height: 100%;
}
.container {
  position: absolute;
  width: 20%;
  top: 43%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  /* border: 1px solid #c0c0c0; */
  padding: 20px;
  background-color: #fff;
}
.inputCommon {
  /* margin-bottom: 30px; */
}
.register {
  text-align: right;
  margin-right: 10px;
  cursor: pointer;
  margin-top: 10px;
  font-size: 14px;
  color: cornflowerblue;
}
.forget {
  text-align: left;
  margin-right: 80px;
  cursor: pointer;
  margin-top: 10px;
  font-size: 14px;
  color: cornflowerblue;
}
@media screen and (max-width: 768px) {
  .container {
    width: 80%;
  }
}
</style>